export * from './lib/svcs-firebase.module';
export * from './lib/services/firebase-auth.service';